import { TMessage } from '../types/messages';
import { TOpenedChat } from '../types/openedChats';

type TFindLastIncomingMessageParams = {
  chat: TOpenedChat;
  pageIndex: number;
  messageIndex: number;
  incoming?: boolean;
};

export function findLastMessage({
  chat,
  pageIndex,
  messageIndex,
  incoming = true,
}: TFindLastIncomingMessageParams): TMessage | null {
  const { message } = chat.pages[pageIndex]?.messages[messageIndex] || {};
  if (message && (!message.isOutcoming || !incoming)) {
    return message;
  }

  if (messageIndex > 0) {
    return findLastMessage({ chat, pageIndex, messageIndex: messageIndex - 1 });
  }

  if (pageIndex > 0) {
    return findLastMessage({
      chat,
      pageIndex: pageIndex - 1,
      messageIndex: chat.pages[pageIndex - 1].messages.length - 1,
    });
  }

  return null;
}
